<template>
  <div id="footer">
    <!-- 主要内容区域 -->
    <div class="footer-main">
      <div class="container">
        <div class="footer-content">
          <!-- 左侧导航链接 -->
          <div class="footer-nav">
            <div class="nav-column">
              <h4 @click="goToBetenWebsite" style="cursor: pointer;">博腾软件</h4>
              <ul>
                <li><a href="javascript:void(0)" @click="goToBetenWebsite">易管账</a></li>
                <li><a href="javascript:void(0)" @click="goToBetenWebsite">购买软件</a></li>
                <li><a href="javascript:void(0)" @click="goToBetenWebsite">软件协议</a></li>
              </ul>
            </div>
            <div class="nav-column">
              <h4>博腾服务</h4>
              <ul>
                <li><router-link to="/product">产品介绍</router-link></li>
                <li><router-link to="/service">技术支持</router-link></li>
                <li><a href="javascript:void(0)" @click="goToBetenWebsite">服务条款</a></li>
              </ul>
            </div>
            <div class="nav-column">
              <h4>解决方案</h4>
              <ul>
                <li><router-link to="/service">定制开发</router-link></li>
                <li><router-link to="/service">行业方案</router-link></li>
              </ul>
            </div>
            <div class="nav-column">
              <h4>渠道合作</h4>
              <ul>
                <li><router-link to="/cooperation">商务合作</router-link></li>
                <li><router-link to="/cooperation">联系方式</router-link></li>
              </ul>
            </div>
            <div class="nav-column">
              <h4>了解博腾</h4>
              <ul>
                <li><router-link to="/newsinformation">新闻资讯</router-link></li>
                <li><router-link to="/companyintroduction">关于我们</router-link></li>
              </ul>
            </div>
          </div>

          <!-- 右侧关注我们和服务热线 -->
          <div class="footer-right">
            <div class="follow-us">
              <h4>关注我们</h4>
              <div class="qr-code">
                <div class="qr-placeholder">
                  <div class="qr-logo">
                    <img src="@/assets/img/homePage/code.png" alt="">
                  </div>
                </div>
              </div>
            </div>
            <div class="service-hotline">
              <div>服务热线</div>
              <div class="phone-number">028-67876657</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 底部版权信息 -->
    <div class="footer-bottom">
      <div class="container">
        <p> Copyright © 2015- {{ new Date().getFullYear() }} © 成都博腾软件有限公司</p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Footer",
  data() {
    return {};
  },
  methods: {
    goToBetenWebsite() {
      // 在新标签页打开博腾软件官网
      window.open('https://e.beten.cn/', '_blank');
    }
  }
};
</script>
<style scoped>
#footer {
  width: 100%;
  color: #fff;
  background: #2a2a2a;
  position: relative;
}

/* 深色背景带斜纹纹理 */
.footer-main {
  background: #2a2a2a;
  background-image: url('../assets/img/footer.png');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  padding: 60px 0;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

.footer-content {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  flex-wrap: wrap;
  gap: 40px;
}

/* 左侧导航区域 */
.footer-nav {
  display: flex;
  gap: 60px;
  flex-wrap: wrap;
}

.nav-column {
  min-width: 120px;
}

.nav-column h4 {
  color: #fff;
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 20px;
  line-height: 1.2;
}

.nav-column ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.nav-column li {
  margin-bottom: 12px;
}

.nav-column a {
  color: #ccc;
  text-decoration: none;
  font-size: 14px;
  transition: color 0.3s ease;
  line-height: 1.4;
}

.nav-column a:hover {
  color: #fff;
}

/* router-link 会被渲染为 a 标签，所以上面的样式会生效 */

/* 右侧区域 */
.footer-right {
  display: flex;
  flex-direction: column;
  /* align-items: center; */
  gap: 30px;
  min-width: 200px;
}

.follow-us h4,
.service-hotline h4 {
  color: #fff;
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 15px;
  /* text-align: center; */
}

/* 二维码区域 */
.qr-code {
  margin-top: 10px;
  margin-bottom: 40px;
  /* display: flex; */
  /* justify-content: center; */
}

.qr-placeholder {
  width: 120px;
  height: 120px;
  /* background: #fff; */
  /* border-radius: 8px; */
  /* display: flex; */
  /* align-items: center; */
  /* justify-content: center; */
  /* box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3); */
}

.qr-logo {
  /* width: 40px; */
  /* height: 40px; */
  /* background: #007bff; */
  /* color: #fff; */
  /* border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  font-weight: bold; */
}

/* 服务热线 */
.service-hotline {
  /* text-align: center; */
}

.phone-number {
  color: #fff;
  font-size: 24px;
  font-weight: bold;
  letter-spacing: 1px;
}

/* 底部版权区域 */
.footer-bottom {
  background: rgba(35, 36, 41, 0.9);
  /* padding: 15px 0; */
  /* border-top: 1px solid #333; */
  height: 40px;
  line-height: 40px;
}

.footer-bottom p {
  color: rgba(153, 153, 153, 1);
  font-size: 14px;
  margin: 0;
  text-align: center;
}

/* 响应式设计 */
@media screen and (max-width: 1024px) {
  .footer-nav {
    gap: 40px;
  }

  .footer-content {
    gap: 30px;
  }
}

@media screen and (max-width: 768px) {
  .footer-main {
    padding: 40px 0;
  }

  .footer-content {
    flex-direction: column;
    align-items: center;
    gap: 40px;
  }

  .footer-nav {
    justify-content: center;
    gap: 30px;
  }

  .nav-column {
    min-width: 100px;
  }

  .nav-column h4 {
    font-size: 15px;
    margin-bottom: 15px;
  }

  .nav-column a {
    font-size: 13px;
  }

  .phone-number {
    font-size: 20px;
  }

  .qr-placeholder {
    width: 100px;
    height: 100px;
  }

  .qr-logo {
    width: 35px;
    height: 35px;
    font-size: 20px;
  }
}

@media screen and (max-width: 480px) {
  .footer-nav {
    flex-direction: column;
    align-items: center;
    gap: 25px;
  }

  .nav-column {
    text-align: center;
  }

  .phone-number {
    font-size: 18px;
  }

  .footer-bottom p {
    font-size: 12px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue